import React from "react";
import { useDispatch } from "react-redux";
import { setActiveOrder } from "../../store/features/orderSlice";

const DraggableCard = ({ id, order }) => {
  const dispatch = useDispatch();

  const setOrder = (activeOrder) => {
    dispatch(setActiveOrder(activeOrder));
  };

  return (
    <div className="orderCard">
      <h3 className="orderCard__title">Заказ: {order.key}</h3>
      <p className="orderCard__amount">
        На сумму: <span>{order.amount}</span>
      </p>
      <p className="orderCard__shop">
        Магазин: <span>{order.shop?.shopName}</span>
      </p>
      <button className="orderCard__btn" onClick={() => setOrder(order)}>
        Подрбнее
      </button>
    </div>
  );
};

export default DraggableCard;
